import { createEntityAdapter } from '@reduxjs/toolkit';

import { Device } from 'data/device';

const devicesOverviewAdapter = createEntityAdapter<Device>({
  selectId: (device) => device.serialNumber,
});

export default devicesOverviewAdapter;
